"use client";

import { createContext, useContext, useMemo, useState } from "react";

const QuizFocusContext = createContext<{
  quizFocused: boolean;
  setQuizFocused: (focused: boolean) => void;
}>({
  quizFocused: false,
  setQuizFocused: () => {},
});

export function QuizFocusProvider({ children }: { children: React.ReactNode }) {
  const [quizFocused, setQuizFocused] = useState(false);
  const value = useMemo(
    () => ({ quizFocused, setQuizFocused }),
    [quizFocused],
  );
  return (
    <QuizFocusContext.Provider value={value}>
      {children}
    </QuizFocusContext.Provider>
  );
}

export function useQuizFocus() {
  return useContext(QuizFocusContext);
}
